"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var Tooltip_exports = {};
__export(Tooltip_exports, {
  Tooltip: () => Tooltip2,
  TooltipGroup: () => TooltipGroup
});
module.exports = __toCommonJS(Tooltip_exports);
var import_jsx_runtime = require("react/jsx-runtime");
var import_polyfill_dev = require("@tamagui/polyfill-dev");
var import_react = require("@floating-ui/react");
var import_core = require("@tamagui/core");
var import_floating = require("@tamagui/floating");
var import_get_size = require("@tamagui/get-size");
var import_popover = require("@tamagui/popover");
var import_popper = require("@tamagui/popper");
var React = __toESM(require("react"));
const TooltipContent = import_popper.PopperContentFrame.extractable(
  React.forwardRef(
    ({ __scopePopover, ...props }, ref) => {
      const popperScope = (0, import_popover.usePopoverScope)(__scopePopover);
      const popper = (0, import_popper.usePopperContext)("PopperContent", popperScope["__scopePopper"]);
      const padding = props.size || popper.size || (0, import_get_size.stepTokenUpOrDown)("size", "$true", -2);
      return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
        import_popover.PopoverContent,
        {
          componentName: "Tooltip",
          disableRemoveScroll: true,
          trapFocus: false,
          padding,
          pointerEvents: "none",
          ref,
          ...props
        }
      );
    }
  )
);
const TooltipArrow = React.forwardRef((props, ref) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popover.PopoverArrow, { componentName: "Tooltip", ref, ...props });
});
const TooltipGroup = ({ children, delay }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_react.FloatingDelayGroup, { delay: React.useMemo(() => delay, [JSON.stringify(delay)]), children });
};
const TooltipComponent = React.forwardRef(function Tooltip(props, ref) {
  const {
    __scopePopover,
    children,
    delay: delayProp,
    restMs = typeof delayProp === "undefined" ? 500 : typeof delayProp === "number" ? delayProp : 0,
    onOpenChange: onOpenChangeProp,
    focus,
    ...restProps
  } = props;
  const popperScope = (0, import_popover.usePopoverScope)(__scopePopover);
  const triggerRef = React.useRef(null);
  const [hasCustomAnchor, setHasCustomAnchor] = React.useState(false);
  const { delay: delayGroup, setCurrentId } = (0, import_react.useDelayGroupContext)();
  const delay = delayProp ?? delayGroup;
  const [open, setOpen] = React.useState(false);
  const id = props.groupId;
  const onOpenChange = (0, import_core.useEvent)((open2) => {
    setOpen(open2);
    if (open2) {
      setCurrentId(id);
    }
    onOpenChangeProp == null ? void 0 : onOpenChangeProp(open2);
  });
  const useFloatingFn = (props2) => {
    const floating = (0, import_react.useFloating)({
      ...props2,
      open,
      onOpenChange
    });
    const { getReferenceProps, getFloatingProps } = (0, import_react.useInteractions)([
      (0, import_react.useHover)(floating.context, { delay, restMs }),
      (0, import_react.useFocus)(floating.context, focus),
      (0, import_react.useRole)(floating.context, { role: "tooltip" }),
      (0, import_react.useDismiss)(floating.context),
      (0, import_react.useDelayGroup)(floating.context, { id })
    ]);
    return {
      ...floating,
      getReferenceProps,
      getFloatingProps
    };
  };
  const useFloatingContext = React.useCallback(useFloatingFn, [id, delay, open]);
  const onCustomAnchorAdd = React.useCallback(() => setHasCustomAnchor(true), []);
  const onCustomAnchorRemove = React.useCallback(() => setHasCustomAnchor(false), []);
  const contentId = (0, import_core.useId)();
  const twoSmallerKey = (0, import_get_size.stepTokenUpOrDown)("size", "$true", -2).key;
  const size = `$${twoSmallerKey}`;
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_floating.FloatingOverrideContext.Provider, { value: useFloatingContext, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(import_popper.Popper, { size, ...popperScope, ...restProps, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    import_popover.__PopoverProviderInternal,
    {
      scope: __scopePopover,
      popperScope: popperScope.__scopePopper,
      contentId,
      triggerRef,
      sheetBreakpoint: false,
      scopeKey: "",
      open,
      onOpenChange: setOpen,
      onOpenToggle: voidFn,
      hasCustomAnchor,
      onCustomAnchorAdd,
      onCustomAnchorRemove,
      children
    }
  ) }) });
});
const Tooltip2 = (0, import_core.withStaticProperties)(TooltipComponent, {
  Anchor: import_popover.PopoverAnchor,
  Arrow: TooltipArrow,
  Content: TooltipContent,
  Trigger: import_popover.PopoverTrigger
});
const voidFn = () => {
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Tooltip,
  TooltipGroup
});
//# sourceMappingURL=Tooltip.js.map
